module.exports = __webpack_public_path__ + "img/bg_v2.674012f9.jpg";